import React, { useState, useEffect } from "react";
import {
  Accordion,
  Icon,
  Form,
  Input,
  Select,
  Dropdown,
  Label,
  Checkbox,
} from "semantic-ui-react";
import ScfoButton from "src/components/shared/ScfoButton";
import {
  toMoney,
  formatRut,
  rutWithDash,
  rutWithNumbers,
  formatMoney,
} from "../../../../../utils/formatter";
import CurrencyOptions from "../../currencyDropdown";
import ContraparteForm from '../contraparte'
import { useTranslation } from "react-i18next";
import "./rigthSidebarForm.scss";
import "../../../../../scss/_semanticForms.scss";
import moment from "moment";
//import CashflowAreaDropdown from "../../formTypes/cashflowAreaDropdown";
import GoBackButton from "../../formTypes/goBackButton/goBackButton"
// import CashflowAreaDropdown from "src/components/general/js/formTypes/cashflowAreaDropdown"
import CashflowAreaDropdown from "src/components/general/js/formTypes/cashflowAreaDropdown"

const manageCurrencyIcon = {
  USD: "dollar",
  EUR: "euro",
  CLP: "dollar",
  UF: "money bill alternate",
  MXN: "dollar",
  GBP: "pound",
  UTM: "money bill alternate",
};

const manageCurrencyName = {
  USD: "Dólar",
  EUR: "Euro",
  CLP: "Peso Chileno",
  GBP: "Libra Esterlina",
  MXN: "Peso Mexicano",
  UF: "UF",
  UTM: "UTM",
};

const currencyOptions = [
  { key: "CLP", value: "CLP", flag: "cl", text: "Peso Chileno" },
  { key: "USD", value: "USD", flag: "us", text: "Dólar" },
  { key: "EUR", value: "EUR", flag: "eu", text: "Euro" },
  //{ key: "MXN", value: "MXN", flag: "mx", text: "Peso Mexicano" },
  //{ key: "GBP", value: "GBP", flag: "gb", text: "Libra Esterlina" },
];

const othertCurrencyOptions = [
  { key: "UF", value: "UF", flag: "cl", text: "UF" },
  { key: "UTM", value: "UTM", flag: "cl", text: "UTM" },
];

export default function RigthSidebarForm({
  section,
  handleSubmit,
  onChange,
  disabled,
  onOkText,
  onCancelText,
  initialData,
  needUpdate,
  setNeedUpdate,
  onCancelFunction,
  dispalyCancelButton,
  editData,
  loading,
  goBackButton,
  goBackButtonFunction
}) {
  const [activeAccordion, setActiveAccordion] = useState(0);
  const { t } = useTranslation("finance");
  const [data, setData] = useState({ currency: "CLP", ...initialData });

  const openAcc = (index) => {
    const newIndex = activeAccordion === index ? -1 : index;
    setActiveAccordion(newIndex);
  };

  const handleChange = (target) => {
    setData({
      ...data,
      [target?.name]:
        target?.accept === "amount"
          ? formatMoney(
            target.value,
            ["CLP"].includes(data?.currency) ? "CLP" : "UF"
          )
          : target?.accept === "rut"
            ? rutWithDash(rutWithNumbers(target.value))
            : target.value,
    });
  };

  const onChangeContraparte = (_, v) => {
    setData({
      ...data,
      [v?.name]: v?.name === "rut" ? formatRut(v?.value) : v?.value,
    });
  };

  const onChangeContraparteDropdown = (_, v) => {
    const { options } = v;
    const selectedOption = options.find((f) => f.key === v.value);
    setData({
      ...data,
      issuerId: selectedOption?.value,
      contraparteRut: formatRut(selectedOption?.rut),
      contraparteName: selectedOption?.name,
    });
  };

  const handleClean = () => {
    setData({});
  };

  //if (data.currency === "USD") initialData.amount = initialData.amount?.toString().replace(".", ",")

  useEffect(() => {
    onChange(data);
  }, [data]);

  useEffect(() => {
    if (needUpdate) {
      setData(initialData);
      setNeedUpdate(false);
    }
  }, [needUpdate]);

  const currencyHandle = (currency) => {
    handleChange({
      name: "currency",
      value: currency,
    })
  }

  const areaHandle = (area) => {
    handleChange({
      name: "area",
      value: area
    })
  }

  const today = moment().format();
  return (
    <Form onChange={({ target }) => handleChange(target)} size="small">
      <Accordion className="fcAccordion">
        {section?.map((element, index) => {
          return (
            <div>
              {element?.display ? (
                <>
                  {element?.subSection?.map((content) => {
                    return (
                      <>
                        {content?.display ? (
                          <>
                            <Form.Field
                              required={content?.required}
                              className="mt-2"
                            >
                              {content?.ranged ? (
                                <>
                                  <Form.Group widths="equal">
                                    <Form.Field
                                      required={content?.firstRequired}
                                    >
                                      <label style={{ fontSize: "10pt" }}>
                                        {content?.firstLabel}
                                      </label>
                                      <Input
                                        placeholder={content?.firstPlaceholder}
                                        name={content?.firstName}
                                        defaultValue={
                                          content?.type === "amount"
                                            ? content?.firstValue
                                              ? toMoney(content?.firstValue)
                                              : ""
                                            : content?.type === "rut"
                                              ? formatRut(content?.firstValue)
                                              : content?.firstValue
                                        }
                                        accept={content?.type}
                                        type={
                                          content?.type === "Date" ? "date" : ""
                                        }
                                        max={
                                          content?.type === "Date"
                                            ? content?.secondValue
                                            : ""
                                        }
                                      />
                                    </Form.Field>
                                    <Form.Field
                                      required={content?.secondRequired}
                                    >
                                      <label style={{ fontSize: "10pt" }}>
                                        {content?.secondLabel}
                                      </label>
                                      <Input
                                        placeholder={content?.secondPlaceholder}
                                        name={content?.secondName}
                                        defaultValue={
                                          content?.type === "amount"
                                            ? content?.secondValue
                                              ? toMoney(content?.secondValue)
                                              : ""
                                            : content?.type === "rut"
                                              ? formatRut(content?.secondValue)
                                              : content?.secondValue
                                        }
                                        accept={content?.type}
                                        type={
                                          content?.type === "Date" ? "date" : ""
                                        }
                                        min={
                                          content?.type === "Date"
                                            ? content?.firstValue
                                            : ""
                                        }
                                      />
                                    </Form.Field>
                                  </Form.Group>
                                  {content?.validate &&
                                    content?.firstValue > content?.secondValue ? (
                                    <Label className="mt-3">
                                      El {content?.firstLabel} no puede ser
                                      mayor a {content?.secondLabel}
                                    </Label>
                                  ) : (
                                    ""
                                  )}
                                </>
                              ) : (
                                <>
                                  <label style={{ fontSize: "10pt" }}>
                                    {content?.label}
                                  </label>
                                  {content?.type === "Dropdown" &&
                                    content?.groups ? (
                                    <CashflowAreaDropdown editData={{ cashflowAreaId: data?.area }} onChange={areaHandle} />
                                  ) : content?.type === "Dropdown" ? (
                                    <Dropdown
                                      selectOnBlur={false}
                                      className="newDropdownIcon"
                                      placeholder={content?.placeholder}
                                      selection
                                      scrolling
                                      value={content?.value}
                                      options={content?.options}
                                      name={content?.name}
                                      onChange={(e, data) => handleChange(data)}
                                      multiple={content?.multiple}
                                      search={content?.search}
                                    />
                                  ) : content?.type === "Select" ? (
                                    <Select
                                      selectOnBlur={false}
                                      placeholder={content?.placeholder}
                                      options={content?.options}
                                      name={content?.name}
                                      value={content?.value}
                                    />
                                  ) : content?.type === "checkbox-radio" ? (
                                    content?.options?.map((check, index) => (
                                      <Checkbox
                                        className={`${index > 0 ? "ml-4" : ""}`}
                                        name={content?.name}
                                        radio
                                        label={check.label}
                                        checked={
                                          check?.value === content?.value
                                        }
                                        value={check?.value}
                                        onChange={(e, val) =>
                                          setData({
                                            ...data,
                                            [val.name]: val.value,
                                          })
                                        }
                                      />
                                    ))
                                  ) : content?.type === "contraparte" ? (
                                    <ContraparteForm
                                      name={content?.name}
                                      onChange={onChangeContraparte}
                                      defaultValue={content?.value}
                                      income={content?.isIncome}
                                      defaultSelectedByRut={
                                        content?.defaultSelectedByRut
                                      }
                                      onChangeContraparteDropdown={
                                        onChangeContraparteDropdown
                                      }
                                    />
                                  ) : content?.type === "amount" ? (
                                    <Form.Input
                                      className="w-100"
                                      name={content?.name}
                                      placeholder={content?.placeholder}
                                      icon={
                                        manageCurrencyIcon[data?.currency] ||
                                        "dollar"
                                      }
                                      iconPosition={"left"}
                                      accept={content?.type}
                                      required
                                      fluid
                                      value={
                                        content?.value
                                          ? formatMoney(content?.value)
                                          : ""
                                      }
                                      action={
                                        <Dropdown
                                          selectOnBlur={false}
                                          button
                                          basic
                                          floating
                                          defaultValue="CLP"
                                          selection
                                          value={data?.currency || "CLP"}
                                          name="currency"
                                          text={t(
                                            `currencyNames.${data?.currency || "CLP"}`,
                                            {
                                              defaultValue:
                                                manageCurrencyName[data?.currency] ||
                                                manageCurrencyName["CLP"],
                                            }
                                          )}
                                          children={
                                            <Dropdown.Menu>
                                              <Dropdown.Header content={t("common.currency")} />
                                              <Dropdown.Divider />
                                              {currencyOptions.map((m) => {
                                                return (
                                                  <Dropdown.Item
                                                    key={m.key}
                                                    value={m.value}
                                                    flag={m.flag}
                                                    text={t(`currencyNames.${m.key}`, { defaultValue: m.text })}
                                                    onClick={(_, v) =>
                                                      handleChange({
                                                        name: "currency",
                                                        value: v.value,
                                                      })
                                                    }
                                                  />
                                                );
                                              })}
                                              <Dropdown.Header content={t("common.otherUnits")} />
                                              <Dropdown.Divider />
                                              {othertCurrencyOptions.map(
                                                (m) => {
                                                  return (
                                                    <Dropdown.Item
                                                      key={m.key}
                                                      value={m.value}
                                                      flag={m.flag}
                                                      text={t(`currencyNames.${m.key}`, { defaultValue: m.text })}
                                                      onClick={(_, v) =>
                                                        handleChange({
                                                          name: "currency",
                                                          value: v.value,
                                                        })
                                                      }
                                                    />
                                                  );
                                                }
                                              )}
                                            </Dropdown.Menu>
                                          }
                                        ></Dropdown>
                                      }
                                    />
                                  ) : (
                                    <Form.Input
                                      className="w-100"
                                      name={content?.name}
                                      placeholder={content?.placeholder}
                                      icon={
                                        content?.type == "amount"
                                          ? manageCurrencyIcon[
                                          data?.currency
                                          ] || "dollar"
                                          : false
                                      }
                                      iconPosition={
                                        content?.type == "amount"
                                          ? "left"
                                          : false
                                      }
                                      accept={content?.type}
                                      type={
                                        content?.type === "Date" ? "date" : ""
                                      }
                                      max={
                                        content?.type === "Date"
                                          ? moment(today)
                                            .add(2, "years")
                                            .format("YYYY-MM-DD")
                                          : ""
                                      }
                                      maxLength={
                                        content?.type === "rut" ? 12 : ""
                                      }
                                      required
                                      fluid
                                      defaultValue={
                                        content?.type === "amount"
                                          ? content?.value
                                            ? content?.value
                                            : ""
                                          : content?.type === "rut"
                                            ? content?.value
                                              ? formatRut(content?.value)
                                              : ""
                                            : content?.value
                                      }
                                      action={
                                        content?.type !== "amount" ? (
                                          false
                                        ) : (
                                          <CurrencyOptions value={data?.currency || "CLP"} onChange={currencyHandle} basic floating button />
                                        )
                                      }
                                    />
                                  )}
                                </>
                              )}
                            </Form.Field>
                          </>
                        ) : (
                          ""
                        )}
                      </>
                    );
                  })}
                </>
              ) : (
                ""
              )}
            </div>
          );
        })}
      </Accordion>
      <Form.Group widths="equal" className="d-flex justify-content-center mt-3 pl-2 pr-1">
        <ScfoButton
          type="button"
          variant="primary"
          className={`mt-3 ${dispalyCancelButton ? "w-100" : ""}`}
          disabled={disabled || loading}
          loading={loading}
          onClick={(e) => {
            e.preventDefault();
            handleSubmit();
          }}
        >
          {onOkText ? onOkText : t("common.submitForm")}
        </ScfoButton>
        {dispalyCancelButton && (
          <ScfoButton
            type="button"
            variant="ghost"
            className="mt-3 w-100"
            onClick={(e) => {
              e.preventDefault();
              onCancelFunction ? onCancelFunction() : handleClean();
            }}
          >
            {onCancelText ? onCancelText : t("common.clearForm")}
          </ScfoButton>
        )}
      </Form.Group>
      {goBackButton ?
        <GoBackButton onClickFunction={goBackButtonFunction} />
        : []}
    </Form>
  );
}
